import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store"
import { v4 as uuidv4 } from 'uuid';

function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function GetMainPageStat() {
  const data = {};
  return client.post("Stats/GetMainPageStat", prepareRequest(data));
}

function GetAccidentsStatusByRole(uid, roleNames) {
  const data = {};
  return client.post(`Stats/GetAccidentsStatusByRole?roleNames=${encodeURIComponent(roleNames)}`, prepareRequest(data));
}

function GetAccidentLastDaysCount() {
  const data = {};
  return client.post("Stats/GetAccidentLastDaysCount", prepareRequest(data));
}

export { GetMainPageStat, GetAccidentsStatusByRole, GetAccidentLastDaysCount };